module.exports = __webpack_public_path__ + "static/media/share.270bd8c2.svg";